import { useEffect, useMemo, useState } from "react";
import {
  EditProps,
  ISubscription,
} from "../../../api/Subscriptions/subscriptionType";
import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import dayjs from "dayjs";
import { DAYJS_DISPLAY_FORMAT, SafeKaroUser } from "../../../context/constant";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditSubscriptionService from "../../../api/Subscriptions/EditSubscription/EditSubscriptionService";
import { header } from "../../../context/constant";
import GetSubscriptionService from "../../../api/Subscriptions/GetSubscription/GetSubscriptionService";
import WarperViewTable from "../Wrapper/WarperViewTable";

const SubsCription = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [userLimitKeys, setUserLimitKeys] = useState<string[]>([]);
  const [discountKey, setDiscountKey] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subsData, setSubsData] = useState<ISubscription[]>();
  const [selectedSubscription, setSelectedSubscription] =
    useState<ISubscription | null>(null);

  console.log("SubsData", subsData);
  console.log("SubsData", subsData);

  let storedTheme: any = localStorage.getItem("user") as SafeKaroUser | null;
  let UserData = storedTheme ? JSON.parse(storedTheme) : storedTheme;

  const columns = useMemo<MRT_ColumnDef<ISubscription>[]>(() => {
    const baseColumns: MRT_ColumnDef<ISubscription>[] = [
      {
        accessorKey: "planName",
        header: "Plan Name",
        size: 200,
      },
      {
        accessorKey: "monthlyAmount",
        header: "Monthly Amount",
        size: 150,
      },
      {
        accessorKey: "policyCount",
        header: "Policy Count",
        size: 100,
      },
      {
        accessorKey: "createdOn",
        header: "Created On",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value as string | number | Date).format(
            DAYJS_DISPLAY_FORMAT
          );
        },
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
        size: 150,
      },
      {
        header: "Status",
        accessorKey: "isActive",
        size: 50,
        Cell: ({ cell }) => {
          const value = cell.getValue<boolean>();
          return value ? (
            <CheckCircleOutlineIcon color="success" />
          ) : (
            <CancelOutlinedIcon color="error" />
          );
        },
      },
    ];

    // const dynamicUserLimitColumns: MRT_ColumnDef<ISubscription>[] =
    //   userLimitKeys.map((key) => ({
    //     accessorKey: `userLimit.${key}`,
    //     header: key.charAt(0).toUpperCase() + key.slice(1) + " Limit",
    //     size: 100,
    //     Cell: ({ row }) => row.original.userLimit?.[key] ?? 0,
    //   }));
    // const dynamicDiscountColumns: MRT_ColumnDef<ISubscription>[] =
    //   discountKey.map((key) => ({
    //     accessorKey: `discount.${key}`,
    //     header: `${key} Discount`,
    //     size: 100,
    //     Cell: ({ row }) => (row.original.userLimit?.[key] ?? 0) + " %",
    //   }));

    return [
      // ...dynamicUserLimitColumns,
      // ...dynamicDiscountColumns,
      ...baseColumns,
    ];
  }, [userLimitKeys, discountKey]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await GetSubscriptionService({ header });
      if (res.status === "success") {
        setSubsData(res.data);
      }
    } catch (error: any) {
      const err = await error;
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleClickEditSubscription = (row: ISubscription) => {
    navigate("edit", { state: row });
  };
  const handleClickChangeStatus = async (row: ISubscription) => {
    try {
      const editData: EditProps = {
        id: row._id,
        header,
        editSubs: { isActive: !row.isActive, updatedBy: UserData.name },
      };
      const res = await EditSubscriptionService(editData);
      if (res.status === "success") {
        fetchData();
      }
    } catch (error: any) {
      const err = await error;
      toast.error(err.message);
    }
  };

  const handleOpenModal = (row: ISubscription) => {
    setSelectedSubscription(row);
    setIsModalOpen(true);
  };
  console.log("selectedSubscription : ", selectedSubscription);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (subsData && subsData?.length > 0) {
      const roleKey = new Set<string>();
      const discountKey = new Set<string>();
      subsData.forEach((item) => {
        if (item.userLimit) {
          Object.keys(item.userLimit).forEach((key) => roleKey.add(key));
        }
        if (item.discount) {
          Object.keys(item.discount).forEach((key) =>
            discountKey.add(`${key}-month`)
          );
        }
      });
      setUserLimitKeys(Array.from(roleKey));
      setDiscountKey(Array.from(discountKey));
    }
  }, [subsData, subsData?.length]);
  console.log("subscription: ", selectedSubscription);
  return (
    <>
      <WarperViewTable title="Subscription">
        <MaterialReactTable
          state={{ isLoading, pagination }}
          columns={columns}
          data={subsData || []}
          enableRowActions
          onPaginationChange={setPagination}
          autoResetPageIndex={false}
          paginateExpandedRows={false}
          positionActionsColumn="last"
          renderRowActions={({ row }) => (
            <div style={{ display: "flex", flexWrap: "nowrap" }}>
              <Tooltip title={"Edit Subscription"}>
                <IconButton
                  color="primary"
                  aria-label={"Edit Subscription"}
                  component="span"
                  onClick={() => {
                    handleClickEditSubscription(row.original as ISubscription);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5 text-addButton"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
              <Tooltip title={"Change Status"}>
                <IconButton
                  color="primary"
                  aria-label={"Change Status"}
                  component="span"
                  onClick={() =>
                    handleClickChangeStatus(row.original as ISubscription)
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5 text-addButton"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
              <Link to="/assign-menu">
                <Tooltip title={"Assign Menu"}>
                  <IconButton
                    color="primary"
                    aria-label={"Assign Menu"}
                    component="span"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6 text-addButton"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                      />
                    </svg>
                  </IconButton>
                </Tooltip>
              </Link>
              {/* //! show all discount data with userCount */}
              <Tooltip title={"Subscription Details"}>
                <IconButton
                  color="primary"
                  aria-label={"Subscription Details"}
                  component="span"
                  onClick={() => handleOpenModal(row.original)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6 text-addButton"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
            </div>
          )}
        />
      </WarperViewTable>

      {/* Modal for Subscription Details */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fullWidth
      >
        <DialogActions sx={{ bgcolor: "rgb(191 219 254)" }}>
          <Button onClick={() => setIsModalOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              style={{ width: "25px", fontWeight: "bold" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </Button>
        </DialogActions>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontSize: 20,
            fontWeight: "bold",
            color: "#027aae",
            backgroundColor: "rgb(191 219 254)",
            marginTop: "-60px",
          }}
        >
          Subscription Details
        </DialogTitle>
        <hr />
        <DialogContent
          sx={{
            bgcolor: "rgb(191 219 254) ",
            padding: "20px",
          }}
        >
          {selectedSubscription && (
            <div>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#E39E2E",
                  fontWeight: "400",
                  fontSize: "16px"
                }}
              >
                <span style={{ color: "#027aae" }}>Plan Name:</span>{" "}
                {selectedSubscription.planName}
              </Typography>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  // gap: "20px",
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  padding: "15px",
                  borderRadius: "8px",
                  filter: "drop-shadow(0px 0px 8px #B6BDC1)",
                }}
              >
                <Typography sx={{ fontSize: "15px" }}>
                  <strong
                    style={{
                      color: "#027aae",
                      fontSize: "15px",
                      fontWeight: "200",
                    }}
                  >
                    Monthly Amount:
                  </strong>{" "}
                  ₹{selectedSubscription.monthlyAmount}
                </Typography>
                <Typography sx={{ fontSize: "15px" }}>
                  <strong
                    style={{
                      color: "#027aae",
                      fontSize: "15px",
                      fontWeight: "200",
                    }}
                  >
                    Policy Count:
                  </strong>{" "}
                  {selectedSubscription.policyCount}
                </Typography>
              </div>
              <Accordion
                sx={{
                  mt: 2,
                  bgcolor: "#fff",
                  color: "white",
                  filter: "drop-shadow(0px 0px 8px #B6BDC1)",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        color: "#027aae",
                        fontWeight: "200",
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  <Typography>
                    <strong
                      style={{
                        color: "#027aae",
                        fontSize: "15px",
                        fontWeight: "200",
                      }}
                    >
                      Discounts
                    </strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "15px",
                    justifyContent: "space-between",
                    bgcolor: "#fff",
                    padding: "15px",
                    color: "#027aae",
                    borderRadius: "8px",
                  }}
                >
                  {Object.keys(selectedSubscription.discount).map(
                    (month, index) => (
                      <Typography
                        key={index}
                        sx={{
                          color: "#027aae",
                          fontSize: "15px",
                          fontWeight: "200",
                        }}
                      >
                        {month} Month :{" "}
                        <span style={{ color: "black", fontSize: "14px" }}>
                          {selectedSubscription.discount[month]}%
                        </span>
                      </Typography>
                    )
                  )}
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{
                  mt: 2,
                  bgcolor: "#fff",
                  color: "white",
                  filter: "drop-shadow(0px 0px 8px #B6BDC1)",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        color: "#027aae",
                        fontWeight: "200",
                        fontSize: "16px",
                      }}
                    />
                  }
                >
                  <Typography>
                    <strong
                      style={{
                        color: "#027aae",
                        fontSize: "15px",
                        fontWeight: "200",
                      }}
                    >
                      User Limit
                    </strong>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    justifyContent: "space-between",
                    bgcolor: "#fff",
                    padding: "15px",
                    color: "#027aae",
                    borderRadius: "8px",
                  }}
                >
                  {Object.keys(selectedSubscription.userLimit).map(
                    (Elem, index) => (
                      <Typography
                        key={index}
                        sx={{
                          color: "#027aae",
                          fontSize: "15px",
                          fontWeight: "200",
                        }}
                      >
                        {Elem} :  <span style={{ color: "black", fontSize: "14px" }}>
                          {selectedSubscription.userLimit[Elem]}
                        </span>
                      </Typography>
                    )
                  )}
                </AccordionDetails>
              </Accordion>

              <Typography sx={{ mt: 2, fontSize: "14px" }}>
                <strong
                  style={{
                    color: "#027aae",
                    fontSize: "15px",
                    fontWeight: "200",
                  }}
                >
                  Status:
                </strong>{" "}
                {selectedSubscription.isActive ? "Active ✅" : "Inactive ❌"}
              </Typography>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Toaster position="bottom-center" reverseOrder={false} />
    </>
  );
};
export default SubsCription;
// https://iimapi.bluesparing.com/api/transaction
